import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GetDownloadFilePath } from '../../../store/app.actions';
import { Store } from '@ngxs/store';
import { AppStateSelectors } from '../../../store/app.selectors';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-download',
  imports: [
    ProgressSpinnerModule,
    ButtonModule,
  ],
  templateUrl: './download.component.html',
})
export class DownloadComponent {
  downloadFilePath: string | null = null;

  constructor(private route: ActivatedRoute, private store: Store) {
    this.route.queryParams.subscribe({
      next: (params: any) => {
        if(params['k'] && params['b']) {
          const key = params['k'];
          const bucket = params['b'];
          this.store.dispatch(new GetDownloadFilePath(key, bucket)).subscribe(() => {
            this.downloadFilePath = this.store.selectSnapshot(AppStateSelectors.getDownloadFilePath);
            if(this.downloadFilePath) {
              window.open(this.downloadFilePath, '_blank');
            }
          })
        }
      },
      error: (error) => {
        console.error('Error fetching download file path: ', error);
      }
    });
  }

}
